import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';
import ProcessTechnology from '../../components/software-company-components/ProcessTechnology/ProcessTechnology';
import icon from '../../images/icons/icon_check_3.svg';
import Services from '../../api/service';

const ServiceSinglePage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [ServiceDetails, setServiceDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const service = Services.find(item => item.slug === slug);
        if (!service) {
            setTimeout(() => {
                navigate('/not-found');
            }, 1500);
        } else {
            console.log('service', service);
            setServiceDetails(service);
            setLoading(false);
        }
    }, [slug, navigate]);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // You can adjust 768px breakpoint
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Call initially to set correct state

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    if (loading) {
        return <div className="spinner"><span>Loading...</span></div>;
    }

    const {
        title,
        description,
        features,
        outComes,
        subservices,
    } = ServiceDetails || {};

    const halfFeaturesLength = Math.ceil(features?.length / 2);

    return (
        <Fragment>
            <main className="page_content service-single-page">

                <section
                    className="page_banner_section text-center"
                    style={{
                        position: 'relative',
                        backgroundImage: isMobile ? 'none' : `url(${ServiceDetails.banner})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        color: '#fff',
                        padding: '60px 15px', // base padding for small screens
                        minHeight: '40vh', // ensures a decent height on mobile
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column'
                    }}
                >
                    {/* Dark Overlay */}
                    {!isMobile && ServiceDetails.banner && (
                        <div
                            style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.6)', // 60% opacity for dark effect
                                zIndex: 1
                            }}
                        />
                    )}

                    {isMobile && (
                        <h2 className="page_title mb-0 text-white fs-2 fs-md-3 fs-lg-1">Our Services</h2>
                    )}
                </section>
                <section className="service_details_section section_space bg-light">
                    <div className="container">
                        <div className="container text-center text-white position-relative z-1">
                            {/*<div className="fs-5 fs-md-4 fs-lg-3 mb-3">*/}
                            {/*    {pageTop}*/}
                            {/*    <span className="badge bg-secondary ms-2">{pagesub}</span>*/}
                            {/*</div>*/}
                            <h1 className="fw-bold mb-0 fs-2 fs-md-3 fs-lg-1">{title}</h1>
                        </div>
                        {/* Service Image - slightly improved with subtle shadow and rounded corners */}
                        {/*<div className="details_item_image position-relative mb-5">*/}
                        {/*    <img*/}
                        {/*        src={sImg}*/}
                        {/*        alt={`${title} service details`}*/}
                        {/*        loading="lazy"*/}
                        {/*        className="service-details-img fade-in w-[500px] rounded-3 shadow-sm"*/}
                        {/*    />*/}
                        {/*</div>*/}

                        {/* Title and description with better spacing */}
                        {/*<h2 className="details_item_title mb-4">{title}</h2>*/}
                        <p className="service-description mb-5 lead">{description}</p>

                        {/* Key Outcomes Section - improved spacing */}
                        {outComes?.length > 0 && (
                            <div className="outcomes-section mb-5 p-4 bg-white rounded-3 shadow-sm">
                                <h3 className="details_item_info_title mb-4">Key Outcomes</h3>
                                <div className="row mb-4">
                                    <div className="col-lg-6">
                                        <ul className="icon_list unordered_list_block">
                                            {outComes.slice(0, halfFeaturesLength).map((feature, index) => (
                                                <li key={index} className="fade-up mb-3 d-flex align-items-start">
                                                    <span className="icon_list_icon me-3">
                                                        <img src={icon} alt="Check Icon" className="img-fluid" />
                                                    </span>
                                                    <span className="icon_list_text">{feature}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="col-lg-6">
                                        <ul className="icon_list unordered_list_block">
                                            {outComes.slice(halfFeaturesLength).map((feature, index) => (
                                                <li key={index} className="fade-up mb-3 d-flex align-items-start">
                                                    <span className="icon_list_icon me-3">
                                                        <img src={icon} alt="Check Icon" className="img-fluid" />
                                                    </span>
                                                    <span className="icon_list_text">{feature}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Sub-Services Section - refined with subtle improvements */}
                        {subservices && subservices.length > 0 && (
                            <section className="my-5 py-4">
                                <h3 className="mb-4 fw-bold">Our {title} Services</h3>
                                <div className="row g-4">
                                    {subservices.map((subService, index) => (
                                        <div key={index} className="col-md-6 col-lg-4">
                                            <div
                                                className="subservice-card h-100 bg-white p-3 rounded-3 shadow-sm"
                                                style={{
                                                    transition: 'transform 0.3s, box-shadow 0.3s',
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.1)';
                                                }}
                                            >
                                                <img
                                                    src={subService.subImg}
                                                    alt={subService.title}
                                                    className="w-100 rounded-3 mb-3"
                                                />
                                                <h4 className="text-start mb-3">{subService.title}</h4>
                                                <p className="text-start text-muted">{subService.details}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        )}

                        {/* Benefits Section - improved with better spacing and subtle styling */}
                        <section className="benefits_section section_space my-5 p-4 bg-white rounded-3 shadow-sm">
                            <h3 className="mb-4 fw-bold">Why Choose {title}?</h3>
                            <div className="row g-4 fade-in">
                                <div className="col-lg-4">
                                    <div className="benefit_item p-4 h-100 border-start border-4 border-primary">
                                        <h4 className="mb-3">High-Quality Services</h4>
                                        <p className="mb-0">We ensure top-notch quality in every project.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="benefit_item p-4 h-100 border-start border-4 border-primary">
                                        <h4 className="mb-3">Expert Team</h4>
                                        <p className="mb-0">Our experts bring years of experience in the industry.</p>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="benefit_item p-4 h-100 border-start border-4 border-primary">
                                        <h4 className="mb-3">On-Time Delivery</h4>
                                        <p className="mb-0">We deliver projects within the deadline without compromising quality.</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Process Technology */}
                        <div className="my-5 py-4">
                            <ProcessTechnology />
                        </div>

                    </div>
                </section>
            </main>

            <CtaSection />
            <Scrollbar />
        </Fragment>
    );
};

export default ServiceSinglePage;
